import { Maybe } from "graphql-tools";
import { WorklistToolTemplateContent } from "graphql/generated/schema-types";
import { parse1224TCMethodSettings } from "./ParseMethodSettings";

export const parseWorklistValues = (
  worklistValues: Maybe<Maybe<WorklistToolTemplateContent>[]> | undefined,
) => {
  const parsedWorklistValues = worklistValues?.map((row) => ({
    sourcePlateIndex: row!.sourcePlatePosition,
    sourceWellId: row!.sourceWellId,
    destPlateIndex: row!.destinationPlatePosition,
    destWellId: row!.destinationWellId,
    transferVol: row!.transferVol ?? "",
  }));

  return parsedWorklistValues;
};

export const parseTemplateMethodSettings = (
  worklistTemplate: Maybe<Maybe<WorklistToolTemplateContent>[]> | undefined,
) => {
  if (!worklistTemplate) return;

  // Templates store times in minutes, so they need no unit conversion
  return parse1224TCMethodSettings(
    worklistTemplate.filter((row): row is WorklistToolTemplateContent => !!row),
    { incomingTimeUnit: "minutes" },
  );
};
